import {styled} from "@mui/system";
import {Grid} from "@mui/material";

const CardHeading = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  padding: "1rem",
}));

export default CardHeading;